import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
// import { useForm } from 'react-hook-form';

export default function MenuSearch() {
    const [searchInput, setSearchInput] = useState('')
    const [searchText, setSearchText] = useState('')
    const [showResult, setShowResult] = useState(false)

    const setSearchTextChange = (e) => {
        setSearchInput(e.target.value)
        setSearchText(e.target.value)
    }
    // const onSubmit = (e) => {
    //     console.log(searchText);
    //     // console.log('data', data);
    //     e.preventDefault()
    //     setSearchText(searchInput)
    //     // setSearchInput('')
    // }
    useEffect(() => {
        searchText.length > 2 ?
            setShowResult(true) : setShowResult(false)
    }, [searchText])

    return (
        <div className='relative'>

            <div className='relative'>
                <input type="text" className='search-input-field' name='search' placeholder="Search Question...." value={searchInput} onChange={(e) => setSearchTextChange(e)} />
                <img src={`/images/icons/search.svg`} alt="search" className='absolute top-2 left-3' />
            </div>

            <div className={`absolute top-8 left-0 w-full bg-dropdownBgColor max-h-[24.19rem] z-20 rounded-b-[0.188rem] font-dropdownFont font-medium cursor-pointer tracking-wider topScrollResult over overflow-auto ${showResult ? 'block' : 'hidden'}`} >
                <div className='text-xs pl-5 py-3'>{searchText}</div>
                <div className='flex justify-between pl-5 pr-7 border-b border-b-transparentWhite15 py-3 items-center searchResult relative' onClick={() => setShowResult(false)}>
                    <div className='text-personaTextFontSize '>Do you listen to music when you work out/exercise?</div>
                    <div className='text-xs text-transparentWhite5'>Mar 2022/ Demo/ </div>
                </div>
                <div className='flex justify-between pl-5 pr-7 border-b border-b-transparentWhite15 py-3 items-center searchResult relative' onClick={() => setShowResult(false)}>
                    <div className='text-personaTextFontSize '>Do you go in nature often?</div>
                    <div className='text-xs text-transparentWhite5'>Dec 2021/ Personas/ / 18-24  Y.O/ North America</div>
                </div>
            </div>
        </div>
    )
}
